import { Checkbox } from '@material-ui/core'
import React from 'react'

import useStyles from './styles/RenderCheckboxRowCell.styles'

interface RenderCheckboxRowCellProps {
  hoveredItem: number | null
  sethoveredItem: React.Dispatch<React.SetStateAction<number | null>>
  value: boolean
  index: number
  weekendIndexes: number[]
  onSaveValue?: (value: boolean) => void
  edited?: boolean
}

const RenderCheckboxRowCell: React.FC<RenderCheckboxRowCellProps> = ({
  hoveredItem,
  sethoveredItem,
  value,
  index,
  weekendIndexes,
  onSaveValue,
  edited
}) => {
  const classes = useStyles()

  return (
    <div
      className={[
        classes.dayContainer,
        hoveredItem === index ? classes.selectedDayContainer : '',
        weekendIndexes.includes(index % 7) ? classes.weekendDayContainer : '',
        edited ? classes.editedDayContainer : ''
      ].join(' ')}>
      <Checkbox
        color="primary"
        checked={value}
        onChange={(event) => {
          onSaveValue?.(event.currentTarget.checked)
        }}
        onClick={() => {
          sethoveredItem(index)
        }}
        onBlur={() => {
          sethoveredItem(null)
        }}
        size="small"
      />
    </div>
  )
}

export default RenderCheckboxRowCell
